import React from "react"

import LocalTime from "components/LocalTime"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

import MicrophoneSelect from "./MicrophoneSelect"
import { JoinAudioRoomDetails } from "./types"

type JoinModalProps = {
  activeAcrClassPeriod: JoinAudioRoomDetails | null
  audioInputDevices: MediaDeviceInfo[]
  selectedAudioInputDeviceId: string
  setSelectedAudioInputDeviceId: (deviceId: string) => void
  microphoneError?: string
  onJoin: () => void
  joining: boolean
  hideMicSelect: boolean
}

const JoinModal: React.FC<JoinModalProps> = ({
  activeAcrClassPeriod,
  audioInputDevices,
  selectedAudioInputDeviceId,
  setSelectedAudioInputDeviceId,
  microphoneError,
  onJoin,
  joining,
  hideMicSelect,
}) => (
  <ModalWithProvidedBody
    isOpen
    hideTrigger
    hideCloseButton
    modalTitle="Join Class"
    modalClassName="bootstrap-modal"
    style={{ overlay: { backgroundColor: "#111" } }}
  >
    <div className="modal-body">
      {activeAcrClassPeriod ? (
        <>
          <p>{activeAcrClassPeriod.acrClass.name}</p>
          <p>Subject: {activeAcrClassPeriod.acrClass.subject.name}</p>
          <p>Teacher: {activeAcrClassPeriod.acrClass.teacher.fullName}</p>
          <p>
            <LocalTime omitDate timestamp={activeAcrClassPeriod.startsAt} />
            &nbsp;&mdash;&nbsp;
            <LocalTime omitDate timestamp={activeAcrClassPeriod.endsAt} />
          </p>
        </>
      ) : (
        <p className="italic">No class currently in session</p>
      )}
      {!hideMicSelect && (
        <>
          <label className="mt-4 block" htmlFor="audio-input-device">
            Microphone
          </label>
          <MicrophoneSelect
            audioInputDevices={audioInputDevices}
            selectedAudioInputDeviceId={selectedAudioInputDeviceId}
            setSelectedAudioInputDeviceId={setSelectedAudioInputDeviceId}
            disabled={joining}
            menuPortalTarget={document.body}
          />
        </>
      )}
      {microphoneError && (
        <p className="mt-2 text-red-600" role="alert">
          {microphoneError}
        </p>
      )}
    </div>

    <div className="modal-footer flex justify-center">
      <button
        type="button"
        className="btn solid green btn-success w-32"
        onClick={onJoin}
        disabled={Boolean(microphoneError) || joining}
      >
        {joining ? "Joining..." : "Join"}
      </button>
    </div>
  </ModalWithProvidedBody>
)

export default JoinModal
